// import {TimeUtils} from '@colonist/utils'
// import {ClientUserState} from '../ClientUserState'
// import {notificationController} from '../EntryShared'
// import {LobbyImage} from '@colonist/types'
// import {TranslationObject} from '@colonist/i18n'

export enum NotificationContentType {
    General,
    Volume,
}

// TODO: Safe to remove this method if still commented out in a few months from March 2025
// export function displayMuteCornerNotification() {
//     const mutedUntil = ClientUserState.userState?.mutedUntil
//     if(mutedUntil == undefined) return
//     if(TimeUtils.isDatePassed(mutedUntil.toString())) return
//     const mutedUntilDate = new Date(mutedUntil)
//     const timeUntilUnmuted = TimeUtils.getDaysHoursOrMinutesBetweenDates(mutedUntilDate, new Date())

//     if(notificationController == undefined) return

//     const unmutedDatePopupMessage: TranslationObject = {key: 'strings:popups.notification.chatMuted', options: {dateType: timeUntilUnmuted.dateType, duration: timeUntilUnmuted.duration}}
//     notificationController.showNotification(LobbyImage.Chat, unmutedDatePopupMessage)
// }
